import { call, put, takeLatest } from '@redux-saga/core/effects';
import Apis from '../../../../api';
import MessageActions from '../../../message/redux/actions';
import AnnoucementActions from './actions';
import AnnouncementsTypes from './types';

const fetchAnnouncementReq = function* fetchAnnouncementReq() {
    try {
        const { data } = yield call(Apis.getAnnouncements);
        yield put(AnnoucementActions.setAnnoucements(data || []));
    } catch (err) {
        yield put(AnnoucementActions.setAnnoucements([]));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

export default function* sagas() {
    yield takeLatest(AnnouncementsTypes.FETCH_ANNOUNCEMENTS_REQ, fetchAnnouncementReq);
}
